import React from "react";
import { Draft, produce } from "immer";

const useImmerReducer = <S, A>(
    reducer: (draft: S, action: A) => void,
    initial: S
): [S, React.Dispatch<A>] => {
    const [state, dispatchBase] = React.useReducer(
        (s: S, action: A) =>
            produce<S>(s, (draft: Draft<S>) => {
                reducer(draft as S, action);
            }),
        initial
    );

    const dispatch = React.useCallback((action: A) => {
        dispatchBase(action);
    }, []);

    return [state, dispatch];
};

export default useImmerReducer;